import classNames from 'classnames';
import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

export interface RawOutputButtonProps {
  showRawOutput: boolean;
  onChange: (newShowRawOutput: boolean) => void;
}

export function RawOutputButton({showRawOutput, onChange}: RawOutputButtonProps): JSX.Element {
  function handleClick(): void {
    onChange(!showRawOutput);
  }

  return (
    <Tooltip title={`${showRawOutput ? 'Hide' : 'Show'} raw output`}>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        className={classNames({'is-active': showRawOutput})}
        icon="table"
        onClick={handleClick}
        size={ButtonSize.MINI}
      />
    </Tooltip>
  );
}

export interface RawOutputButtonOutput {
  rawOutputButton: JSX.Element;
  showRawOutput: boolean;
}

export const showRawOutputState = makeUseGlobalClientState<boolean>(false);

export function useRawOutputButton(viewStateId: string): RawOutputButtonOutput {
  const [showRawOutput, setShowRawOutput] = showRawOutputState.useGlobalClientState(viewStateId);

  return {
    rawOutputButton: <RawOutputButton showRawOutput={showRawOutput} onChange={setShowRawOutput} />,
    showRawOutput,
  };
}
